<script>
import ClaimsForm from "@components/support-areas/internal-control/condusef/claims-form.vue";
export default {
  name: "complaint-reports",
  components: {ClaimsForm},
}
</script>

<template>
  <div class="container mt-10">
    <span class="px-5 pill-danger pulse-danger">Sanbox</span>
    <vx-card title="Reclamaciones" class="mt-5">
      <claims-form />
    </vx-card>
  </div>
</template>